shape = {};
shape.shapes = [];

shape.create = function (json) {
  var newShape = new PIXI.Container();
  shape.shapes.push(newShape);
  return newShape;
};

shape.updateShape = function (shapeObject) {
  var json = shapeObject.Props;
  var width;
  var height;

  if (shapeObject.Props[layoutController.getCurrentLayout()].width) {
    width = shapeObject.Props[layoutController.getCurrentLayout()].width;
  } else if (
    shapeObject.Props["default"] &&
    shapeObject.Props["default"].width
  ) {
    width = shapeObject.Props["default"].width;
  } else {
    width = json.width;
  }

  if (shapeObject.Props[layoutController.getCurrentLayout()].height) {
    height = shapeObject.Props[layoutController.getCurrentLayout()].height;
  } else if (
    shapeObject.Props["default"] &&
    shapeObject.Props["default"].height
  ) {
    height = shapeObject.Props["default"].height;
  } else {
    height = json.height;
  }

  shapeObject.graphics.clear();
  shapeObject.graphics.beginFill(json.colour, json.alpha);
  switch (json.shape) {
    case "square":
      {
        shapeObject.graphics.drawRect(
          -width * json.anchorX,
          -height * json.anchorY,
          width,
          height
        );
      }
      break;

    case "circle":
      {
        //container.graphics.drawEllipse(-json.width * json.anchorX,-json.height * json.anchorY,json.width/2,json.height/2);
        shapeObject.graphics.drawEllipse(
          width / 2 - width * json.anchorX,
          height / 2 - height * json.anchorY,
          width / 2,
          height / 2
        );
      }
      break;

    case "roundedRect":
      {
        shapeObject.graphics.drawRoundedRect(
          -width * json.anchorX,
          -height * json.anchorY,
          width,
          height,
          json.radius
        );
      }
      break;
  }
  shapeObject.graphics.endFill();
};

shape.updateAllShapes = function () {
  for (var i = 0; i < shape.shapes.length; i++) {
    shape.updateShape(shape.shapes[i]);
  }
};

shape.initialise = function (json, container, resources) {
  // Create shape
  if (
    json.shape !== "square" &&
    json.shape !== "circle" &&
    json.shape !== "roundedRect"
  ) {
    console.error(
      "Shape " + json.name + " must be either square, circle or roundedRect"
    );
    return;
  }

  if (checkForUndefined(json.colour)) {
    // Default colour is black
    json.colour = 0;
  } else {
    json.colour = parseInt(json.colour);
  }

  if (checkForUndefined(json.alpha)) {
    // Default alpha is 0.5
    json.alpha = 0.5;
  }

  if (checkForUndefined(json.anchor)) {
    json.anchor = 0.0;
  }

  if (checkForUndefined(json.anchorX)) {
    json.anchorX = json.anchor;
  }

  if (checkForUndefined(json.anchorY)) {
    json.anchorY = json.anchor;
  }

  container.graphics = resourceManager.createObject(
    "graphics",
    "graphics",
    json.FQN
  );
  shape.updateShape(container);
};

shape.getFilesRequired = function (json) {
  return [];
};

Reflex.registerEventHandler("resize", shape.updateAllShapes);
resourceManager.registerObjectType(
  "shape",
  shape.create,
  shape.initialise,
  shape.getFilesRequired
);
